<template>
  <div
    id="idModalCancelJob"
    class="modal-job-monitoring">
    <div class="wrap-modal-job-monitoring">
      <img
        src="@/assets/icon/cancel-job.svg"
        alt="cancel-job-icon"
      >
      <p class="title">Are you sure to <span class="cancel">Cancel</span> ?</p>
      <p class="info">All Current Waiting Job</p>
      <div class="button-modal-job-monitoring">
        <b-button
          class="btn-cancel-waiting"
          @click="handleCancelJob"
        >
          Yes
        </b-button>
        <b-button
          @click="closeModalCancelJob"
        >
          Cancel
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import jApi from '@/services/jApi';
import { mapActions } from 'vuex';

export default {
  props: {
    visprogId: { type: String, default: '', required: true },
    isDedicated: { type: Boolean, default: false },
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'toggleSuccess', 'showLoading', 'hideLoading']),

    closeModalCancelJob() {
      this.$emit('close');
    },

    handleCancelJob() {
      if (this.isDedicated) this.cancelAllDedicatedJob();
      else this.cancelAllJob();
      this.closeModalCancelJob();
    },

    async cancelAllJob() {
      this.showLoading();
      try {
        const api = jApi.generateApi();
        const res = await api.post(`nocode-job-monitor/jobs/${this.visprogId}/cancel`);
        if (res.data.error) {
          this.hideLoading();
          this.toggleProblem(res.data.message);
        } else {
          this.hideLoading();
          this.toggleSuccess(res.data.message);
          this.$emit('completed');
        }
      } catch (err) {
        this.hideLoading();
        this.toggleProblem(err.response.data.message || err.message);
      }
    },

    async cancelAllDedicatedJob() {
      this.showLoading();
      try {
        const api = jApi.generateApi();
        const req = { params: { job_id: this.visprogId } };
        const res = await api.get('nocode-dedicated-job/cancel', req);
        if (res.data.error) {
          this.hideLoading();
          this.toggleProblem(res.data.message);
        } else {
          this.hideLoading();
          this.toggleSuccess(res.data.message);
          this.$emit('completed');
        }
      } catch (err) {
        this.hideLoading();
        this.toggleProblem(err.response.data.message || err.message);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalCancelJob.vue